module.exports = [{
      plugin: require('/home/travis/build/graphile/graphile.github.io/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/graphile/graphile.github.io/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/graphile/graphile.github.io/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/graphile/graphile.github.io/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
